import Image from "next/image";

import styled from "styled-components";

import { grayScale, pink } from "@enkor/design/colors";

export const AVATAR_SIZE = 48;

export const Container = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow-y: auto;

  max-height: 80vh;
  margin-top: 16px;
  padding: 24px 0;
  border-top: 1px solid ${grayScale.main};
`;

export const MemberContainer = styled.li<{ $isClickable: boolean }>`
  display: flex;
  gap: 16px;

  padding: 0 16px;

  :hover {
    cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};
  }
`;

export const MemberInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const AvatarImageWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  overflow: hidden;

  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border-radius: 50%;
`;

export const HostMark = styled.div`
  position: absolute;
  right: 0;
  bottom: 0px;
  display: flex;

  padding: 2px;
  border-radius: 50%;

  background-color: ${pink.main};
`;

export const MemberAvatar = styled(Image)`
  object-fit: cover;

  width: 100%;
  height: 100%;
`;
